import type { ReactElement } from 'react';
import { Construction } from '../../components';

export const Account = (): ReactElement => <Construction />;
